import { useBrowserStore } from '@/stores/browserStore';
import { Image, Maximize2, X, Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';

export function ScreenshotPreview() {
  const { currentScreenshot, annotatedScreenshot, currentSnapshot } = useBrowserStore();
  const [isExpanded, setIsExpanded] = useState(false);
  const [showAnnotations, setShowAnnotations] = useState(true);

  // Use annotated screenshot if available and annotations are enabled
  const displayScreenshot = showAnnotations && annotatedScreenshot
    ? annotatedScreenshot
    : currentScreenshot;

  if (!currentScreenshot) {
    return (
      <div className="bg-card border border-border rounded-lg p-4">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Image className="h-4 w-4" />
          <span className="text-sm">No screenshot</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="bg-card border border-border rounded-lg overflow-hidden">
        <div className="flex items-center justify-between px-3 py-2 border-b border-border">
          <div className="flex items-center gap-2">
            <Image className="h-4 w-4 text-muted-foreground" />
            <span className="text-sm font-medium text-foreground">Screenshot</span>
            {annotatedScreenshot && (
              <span className="text-xs text-muted-foreground">
                ({showAnnotations ? 'annotated' : 'original'})
              </span>
            )}
          </div>
          <div className="flex items-center gap-1">
            {annotatedScreenshot && (
              <button
                onClick={() => setShowAnnotations(!showAnnotations)}
                className="p-1 rounded hover:bg-secondary transition-colors"
                title={showAnnotations ? 'Hide element boxes' : 'Show element boxes'}
              >
                {showAnnotations ? (
                  <Eye className="h-4 w-4 text-emerald-500" />
                ) : (
                  <EyeOff className="h-4 w-4 text-muted-foreground" />
                )}
              </button>
            )}
            <button
              onClick={() => setIsExpanded(true)}
              className="p-1 rounded hover:bg-secondary transition-colors"
              title="Expand"
            >
              <Maximize2 className="h-4 w-4 text-muted-foreground" />
            </button>
          </div>
        </div>
        <div
          className="cursor-pointer hover:opacity-90 transition-opacity"
          onClick={() => setIsExpanded(true)}
        >
          <img
            src={displayScreenshot ?? undefined}
            alt={currentSnapshot?.title || 'Page screenshot'}
            className="w-full h-auto"
          />
        </div>
      </div>

      {/* Expanded modal */}
      {isExpanded && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-8"
          onClick={() => setIsExpanded(false)}
        >
          <div className="relative max-w-full max-h-full">
            <div className="absolute -top-10 right-0 flex items-center gap-2">
              {annotatedScreenshot && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAnnotations(!showAnnotations);
                  }}
                  className="p-2 rounded bg-secondary text-foreground hover:bg-secondary/80 flex items-center gap-2"
                >
                  {showAnnotations ? (
                    <>
                      <Eye className="h-4 w-4 text-emerald-500" />
                      <span className="text-sm">Boxes On</span>
                    </>
                  ) : (
                    <>
                      <EyeOff className="h-4 w-4" />
                      <span className="text-sm">Boxes Off</span>
                    </>
                  )}
                </button>
              )}
              <button
                onClick={() => setIsExpanded(false)}
                className="p-2 rounded bg-secondary text-foreground hover:bg-secondary/80"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <img
              src={displayScreenshot ?? undefined}
              alt={currentSnapshot?.title || 'Page screenshot'}
              className="max-w-full max-h-[90vh] rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </>
  );
}
